var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"linked-content-tools"},[_c('action',{staticClass:"print",attrs:{"name":"link","with-icon":"mdi-printer","nochevron":true,"small":true},on:{"click":function($event){return _vm.printWindow()}}},[_vm._v(" Imprimer ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }